<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <VehicleSelect :modalList="cars" @onChecked="onChecked">
            <template #start>
              <div class="sinput">
                <SearchField :form="sform" :formCtrl="sformCtrl" @onSearch="onSearch" @onReset="onReset"
                  @onChange="onSearchItemChange" />
              </div>
            </template>
          </VehicleSelect>
          <!-- 其他控件 -->
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <!-- <div class="contit">运单信息</div> -->
          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 结款提醒组件 -->
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, orderViewMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "普通运单", path: "/order/nocontract" },
        { name: "运单添加" },
      ],
      sform: {
        car_type: undefined,
        license: undefined,
      },
      sformCtrl: [
        {
          label: "车辆类型",
          keyName: "car_type",
          type: "select",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
        },
      ],
      form: {
        pricing_id: undefined,
        cprice: undefined,
        dprice: undefined,
        message: undefined,
        nid: undefined,
        shipperid: undefined,
        drman: undefined,
        drtel: undefined,
        coaddress: undefined,
        predict_loading_date: undefined,
        predict_unloading_date: undefined,
        enman: undefined,
        ertel: undefined,
        enaddress: undefined,
        ischartcar: 1,
        // 抵消掉orderViewMixin中的默认值
        istime: null,
      },
      formCtrl: [
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "select",
          options: [],
        },
        {
          label: "货物名称",
          keyName: "name",
          type: "select",
          err: "请选择货物名称",
          options: [],
        },
        {
          label: "计价方式",
          keyName: "pricing_name",
          type: "select",
          options: [],
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
        },
      ],
      fhperson: [],
      shperson: [],
      rules: {
        shname: [
          { required: true, message: "请选择客户名称", trigger: "blur" },
        ],
        // nid: [
        //   { required: true, message: "请选择货物名称", trigger: "blur" },
        // ],
        pricing_id: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        pricing_name: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],

        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        // dprice: [
        //   { required: true, message: "请填写司机单价", trigger: "blur" },
        // ],
        // message: [
        //   { required: true, message: "请填写信息费", trigger: "blur" },
        // ],
        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" },
        ],
        drtel: [
          { required: true, message: "请填写正确联系电话", validator: this.checkPhone, trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" },
        ],
        ertel: [
          { required: true, message: "请填写正确联系电话", validator: this.checkPhone, trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
        predict_loading_date: [
          { required: true, message: "请填写装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请填写卸货日期", trigger: "blur" },
        ],
      },
      cars: [],
      custom: [],
    };
  },
  methods: {
    setDetail() {
      const keys = [
        'shipperid',
        'name',
        // 'shname',
        'nid',
        'pricing_id',
        'pricing_name',
        'cprice',
        'dprice',
        'coaddress',
        'drman',
        'drtel',
        'enaddress',
        'enman',
        'ertel',
      ]
      keys.map(k => {
        this.$set(this.form, k, this.detail[k])
      })
      // 如果options先到则在这里匹配
      this.setPricingName()
      this.setCustom()
      console.log('再派一单')
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },

    paramsPackage(params, object) {
      const keys = [
        'car_list',

        'shipperid',
        // 'shname',
        'nid',
        'name',
        'pricing_id',

        'cprice',
        'dprice',

        'coaddress',
        'drman',
        'drtel',
        'enaddress',
        'enman',
        'ertel',
        'ertel',

        'predict_loading_date',
        'predict_unloading_date',

        'repaytime',
        'istime',
        'order_remark',

        // 附加费用
        'additional_fee_items',
        // 报单id
        'd_id',
      ]
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && keys.includes(key)) {
          // console.log(key, object[key], typeof object[key])
          // const value = object[key]
          // params[key] = value;
          this.$set(params, key, object[key])
        }
      }
      // console.log('params', { ...params })
    },

    onChecked(arr) {
      console.log(arr)
      this.form.car_list = [...arr]
    },
    formOrtherValidate() {
      let boo = true
      const { car_list, predict_loading_date, predict_unloading_date } = this.form
      if (!car_list || !car_list.length) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
        boo = false
      } else if (new Date(predict_loading_date).getTime() > new Date(predict_unloading_date).getTime()) {
        this.$message({
          type: 'error',
          message: '装货日期不能晚于卸货日期！'
        });
        boo = false
      }
      return boo
    },
    setOptions({ product, custom, pricing, car_type, additional_fee_options }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'pricing_name') {
          this.setPricingOption(pricing, c.options)
          if (!this.detail['pricing_id']) {
            this.$set(this.form, 'pricing_id', pricing[0]['id'])
            this.$set(this.form, 'pricing_name', pricing[0]['name'])
          } else {
            // 如果detail先到则在这里匹配
            this.setPricingName()
          }
        } else if (c.keyName == 'nid' && product && product.length) {
          this.product.push(...product)
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        } else if (c.keyName == 'name' && product && product.length) {
          this.product.push(...product)
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        } else if (c.keyName == 'shipperid' && custom && custom.length) {
          this.custom.push(...custom)
          c.options = custom.map(v => {
            return {
              label: v.name + '-' + v.member,
              value: v.id,
            }
          })
        } else if (c.keyName == 'shname' && custom && custom.length) {
          this.custom.push(...custom)
          c.options = custom.map(v => {
            return {
              label: v.name + '-' + v.member,
              value: v.name + '-' + v.member,
            }
          })
          this.setCustom()
        }
      })
      // 选择车辆组件中，车辆类型下拉框选项
      if (car_type && car_type.length) {
        this.sformCtrl.map(c => {
          if (c.keyName == 'car_type') {
            c.options = car_type.map(v => {
              return {
                label: v.name,
                value: v.name,
              }
            })
          }
        })
      }

      // 附加费用
      if (additional_fee_options && additional_fee_options.length) {
        const o = additional_fee_options
        o.map(v => {
          const ctrl = {
            label: v.authname,
            keyName: v.enname,
            type: "number",
          }
          this.formCtrlfee.push(ctrl)
        })
      }

      // console.log('form', { ...this.form })
    },
    onInput({ key, value }) {
      // console.log(key, value, this.form.shipperid)
      const id = this.form.shipperid
      if (key === 'order_remark') {
        if (this.$refs && this.$refs.form3Item0) {
          const dom = this.$refs.form3Item0[0].$el
          // console.log(dom)
          const inner = dom.querySelector('.el-textarea__inner')
          // console.log(inner)
          // console.log(inner.scrollHeight)
          // const oheight = inner.scrollHeight
          inner.style.height = 'auto'; // 重置高度
          // 高度设为auto后scrollHeight会改变，用原始高度判断，一行时强制一行高度，其他情况随内容升高
          // if (oheight < 55) {
          //   inner.style.height = 40 + 'px'
          // } else {
          inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
          // }
        }
      } else if (id && value) {
        this.inputSearch(id, key, value)
      } else if (!value) {
        if (key === 'drman') {
          this.formCtrlIn.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.$set(this.form, key, value)
        } else if (key === 'coaddress') {
          this.formCtrlIn.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.$set(this.form, key, value)
        } if (key === 'enman') {
          this.formCtrlOut.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.$set(this.form, key, value)
        } if (key === 'enaddress') {
          this.formCtrlOut.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.$set(this.form, key, value)
        }
        this.$forceUpdate()
      }
      // console.log({ ...this.form })
    },
    inputSearch(id, key, value) {
      // console.log(id, key, value)
      let url = `${this.baseUrl}/shippervague`;
      const params = {
        id,
      }
      if (key === 'drman') {
        params['fhperson'] = value
      } else if (key === 'coaddress') {
        params['fhdizhi'] = value
      } if (key === 'enman') {
        params['shperson'] = value
      } if (key === 'enaddress') {
        params['shdizhi'] = value
      } else if (!['drman', 'coaddress', 'enman', 'enaddress'].includes(key)) {
        return
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          if (key === 'drman') {
            this.formCtrlIn.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.member,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } else if (key === 'coaddress') {
            this.formCtrlIn.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.address,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } if (key === 'enman') {
            this.formCtrlOut.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.member,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } if (key === 'enaddress') {
            this.formCtrlOut.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.address,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          }
          this.$forceUpdate()
          // console.log([...this.formCtrlIn])
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      if (key === 'drman') {
        this.formCtrlIn.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        if (value && value['member']) {
          this.$set(this.form, key, value['member'])
        }
        if (value && value['phone']) {
          this.$set(this.form, 'drtel', value['phone'])
        }
      } else if (key == 'coaddress') {
        this.formCtrlIn.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        if (value && value['address']) {
          this.$set(this.form, key, value['address'])
        }
      } if (key === 'enman') {
        this.formCtrlOut.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        if (value && value['member']) {
          this.$set(this.form, key, value['member'])
        }
        if (value && value['phone']) {
          this.$set(this.form, 'ertel', value['phone'])
        }
      } if (key === 'enaddress') {
        this.formCtrlOut.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        if (value && value['address']) {
          this.$set(this.form, key, value['address'])
        }
      }
      this.$forceUpdate()
    },
    onSearch() {
      this.getCar();
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (['car_type'].includes(key)) {
        this.getCar()
      }
    },
    onReset() {
      this.sform = {
        car_type: undefined,
        license: undefined,
      }
      this.getCar();
    },
    getVtype() {
      let url = "cartype/rec";
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // const { msg, data } = res
        console.log(res.data)
        this.sformCtrl.map(c => {
          if (c.keyName == 'car_type') {
            res.data.map(v => {
              c.options.push({
                label: v.name,
                value: v.name,
              })
            })
          }
        })
      }, err => {
        console.log(err)
      })
    },
    getCar() {
      // this.cars = [];
      let url = "order/searchcar";
      const params = {
        userid: this.user.id,
        ...this.sform
      }
      this.post(url, params, ({ driver }) => {
        // const { msg, data } = res
        // console.log(driver)
        if (driver && driver.length) {
          this.cars = [...driver]
        } else {
          this.cars = []
        }
      }, err => {
        console.log(err)
      })
    },

    getReportOrder() {
      let url = `declaration/item`;
      const params = {
        id: this.r_id,
      }

      this.post(url, params, ({ msg, data }) => {
        // console.log(data)
        if (msg === 'success' && data) {
          this.detail = { ...data }
          const {
            p_id,
            product,
            pricing_id,
            coaddress,
            drman,
            drtel,
            enaddress,
            enman,
            ertel,
            predict_loading_date,
            predict_unloading_date,
          } = data

          this.form = {
            ...this.form,
            d_id: this.r_id,
            shipperid: this.c_id,
            nid: p_id,
            name: product,
            pricing_id,
            coaddress,
            drman,
            drtel,
            enaddress,
            enman,
            ertel,
            predict_loading_date,
            predict_unloading_date,
          }

          this.setCustom()
          this.setPricingName()
          console.log('报单派单')
          this.$forceUpdate()
          console.log('detail', { ...this.detail })
          console.log('form', { ...this.form })
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setCustom() {
      // 再派一单获取detail，取出shipperid
      let { shipperid } = this.detail
      // 如果是报单派单，不获取detail，通过c_id获取详情信息
      if (this.c_id) {
        shipperid = this.c_id
      }
      if (this.custom && this.custom.length) {
        this.custom.map(v => {
          // 匹配shipperid，设置合成用户名
          if (v.id == shipperid) {
            this.$set(this.form, 'shname', v.name + '-' + v.member)
            this.$forceUpdate()
            // console.log('form', { ...this.form })
          }
        })
      }
    },
  },
  created() {
    // console.log(this.$route.path)
    if (this.$route.path.includes('/reportOrder/dispatch')) {
      // 客户报单派单
      this.breadcrumb = [
        { name: "报单管理", path: `/reportOrder/list` },
        { name: "报单列表", path: `/reportOrder/list` },
        { name: "报单派单" }
      ]
    }
  },
  mounted() {
    this.formCtrlfee = []
    this.getOptions({ userid: this.user.id });
    // this.getVtype();
    this.getCar();
    const { c_id, r_id } = this.$route.query
    // console.log(c_id)
    if (c_id) {
      this.c_id = c_id
      this.r_id = r_id
      this.formCtrl.map(v => {
        if (v.keyName === 'shname') {
          v.disabled = true
        }
      })
      this.getReportOrder()
    }
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/ .sinput {
  .fillet {
    padding: 0;
    box-shadow: none;
  }

  .retrieval {
    margin: 0;

    .el-form-item__content {
      .el-input {
        width: 150px !important;
      }
    }

    .el-form {
      margin-bottom: 0px !important;
    }

    .el-form-item {
      margin: 0 0 10px 0;
    }
  }



}

.el-form-items {
  .tit_label {
    display: flex;

    .title {
      margin-left: 40px;
      cursor: pointer;
    }
  }

}
</style>
